export const enum NumberOperator {
    Equal = '=',
    NotEqual = '!=',
    GreaterThan = '>',
    LessThan = '<',
    GreaterThanOrEqual = '>=',
    LessThanOrEqual = '<=',
}
